import {useEffect} from 'react'

import useEventCallback from '../../../../hooks/useEventCallback'

export function useSearchShortcutHandler(enabled: boolean, callback: () => unknown) {
  const onKeyDown = useEventCallback((event: KeyboardEvent) => {
    if (
      enabled &&
      (navigator.platform === 'MacIntel' ? event.metaKey : event.ctrlKey) &&
      (event.code === 'KeyK' || event.key === 'k')
    ) {
      event.stopPropagation()
      event.preventDefault()
      callback()
    }
  })

  useEffect(() => {
    document.addEventListener('keydown', onKeyDown, true)
    document.addEventListener('keyup', onKeyDown, true)
    return () => {
      document.removeEventListener('keydown', onKeyDown, true)
      document.removeEventListener('keyup', onKeyDown, true)
    }
  }, [onKeyDown])
}
